export const OPEN_TERMS = "terms/OPEN_TERMS";
export const CLOSE_TERMS = "terms/CLOSE_TERMS";
